import { BreakpointObserver, Breakpoints, LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';

import { NavService } from '@services/nav.service';
import { PreLoadService } from '@services/pre-load.service';
import { UserService } from '@services/user.service';

import { LoadingBarComponent } from './loading-bar/loading-bar.component';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { ShellService } from './shell.service';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'bk-shell',
  imports: [
    SidebarComponent,
    ButtonModule,
    CommonModule,
    DrawerModule,
    LoadingOverlayComponent,
    LayoutModule,
    LoadingBarComponent,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class Shell2Component implements OnInit {
  userService = inject(UserService);

  navService = inject(NavService);
  preLoadService = inject(PreLoadService);
  shellService = inject(ShellService);

  isAuthenticated = toSignal(this.userService.isAuthenticated$);
  customerId = toSignal(this.navService.customerId$);
  showSidebar = toSignal(this.navService.showSidebar$);

  breakpointObserver = inject(BreakpointObserver);
  destroyRef = inject(DestroyRef);

  isLarge = signal(false);

  ngOnInit() {
    this.breakpointObserver
      .observe([Breakpoints.Large, Breakpoints.XLarge])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.isLarge.set(result.matches);
        this.navService.showSidebar$.next(result.matches);
      });
  }

  toggleSidebar() {
    this.navService.toggleSidebar();
  }

  onNav(isLarge: boolean) {
    if (isLarge) return;

    this.navService.toggleSidebar();
  }
}
